import React from 'react';
import { TextAd, ProductAd } from '../types';

type UnifiedAd = TextAd | ProductAd;

interface AdRendererProps {
    ad: UnifiedAd;
    slotNumber: number;
    onAdClick?: (ad: UnifiedAd) => void;
    onVisible?: () => void;
}

export const ProductAdRenderer: React.FC<AdRendererProps> = ({
    ad,
    slotNumber,
    onAdClick,
    onVisible,
}) => {
    const handleClick = (event: React.MouseEvent) => {
        event.preventDefault();
        const clickUrl = `${ad.click_url}&slot-number=${slotNumber}`;
        window.open(clickUrl, '_blank', 'noopener,noreferrer');
        onAdClick?.(ad);
    };

    const handleImpression = () => {
        const img = new Image();
        img.src = `${ad.impression_url}&slot-number=${slotNumber}`;
        onVisible?.();
    };

    React.useEffect(() => {
        handleImpression();
    }, []);

    const isProduct = (a: UnifiedAd): a is ProductAd => 'price' in a;

    const formatPrice = (price: number, currency?: string) => {
        try {
            return new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: currency || 'USD',
            }).format(price);
        } catch {
            return `${currency || 'USD'} ${price}`;
        }
    };

    const priceBlock = isProduct(ad) ? (
        <div className="ad-price">
            {ad.sale_price && ad.sale_price < ad.price ? (
                <>
                    <span className="sale-price">{formatPrice(ad.sale_price, ad.price_currency)}</span>
                    <span className="original-price">{formatPrice(ad.price, ad.price_currency)}</span>
                </>
            ) : (
                <span className="price">{formatPrice(ad.price, ad.price_currency)}</span>
            )}
        </div>
    ) : null;

    return (
        <button type="button" className="admarketplace-product-ad" onClick={handleClick}>
            <div className="ad-image">
                <img
                    src={ad.image_url}
                    alt={ad.term}
                    onError={(e) => {
                        const target = e.target as HTMLImageElement;
                        target.style.display = 'none';
                    }}
                />
            </div>
            <div className="ad-content">
                <h3 className="ad-title">{ad.term}</h3>
                {priceBlock}
                <p className="ad-sponsor">Sponsored by {ad.adv_name}</p>
            </div>
            <div className="ad-footer"><span className="ad-brand" title={ad.adv_name}>{ad.term}</span><span className="ad-badge">Ad</span></div>
        </button>
    );
};


